import { Stack, useTheme } from "@mui/material";
import { MprcFeedTypography } from "components/MprcFeedTypography";
import { FeedType } from "generated/CoreApi_v1";
import React from "react";
import { useTranslation } from "react-i18next";
import { StickerBox } from "views/knowledge/components/card/behaviors/common/StickerBox";
import { useCardContext } from "views/knowledge/components/card/CardBuilder";

///
export const TitleContentPage = () => {
    const { pub, otherInfo } = useCardContext();
    const theme = useTheme();
    const { t } = useTranslation("knowledge");

    const isBlocked = pub.blocked?.blockedOn != undefined;

    var borderStyle: React.CSSProperties | undefined = otherInfo?.feedType != FeedType.ContentPage && (pub.interaction.isNewPublication || pub.blocked?.firstAccessAfterBlock === true || pub.rejected?.firstAccessAfterRejected === true)
        ? { borderLeft: "4px solid", borderLeftColor: theme.palette.warning.main, paddingLeft: theme.spacing(1) }
        : undefined;

    return (
        <div style={borderStyle}>
            <MprcFeedTypography variant="title" component="div" color={isBlocked ? "warning" : undefined}>
                <span title={pub.title}>{pub.title}</span>
            </MprcFeedTypography>

            <Stack spacing={0.5} alignItems="flex-end" direction="row">
                {isBlocked && <StickerBox name={t("Feed.Card.Common.BlockedText")} textColor={theme.palette.common.white} backgroundColor={theme.palette.warning.main} />}
                {pub.sticker && <StickerBox name={pub.sticker.name} textColor={pub.sticker.textColor} backgroundColor={pub.sticker.backgroundColor} />}
            </Stack>
        </div>
    );
};
